import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

// Function to load locale messages from JSON files
function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.json$/i);
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key);
    }
  });
  return messages;
}

// Retrieve the saved locale from localStorage (if any)
const savedLocale = localStorage.getItem('user-locale') || 'en';

// Create the VueI18n instance
const i18n = new VueI18n({
  locale: savedLocale, // Set the locale from localStorage
  fallbackLocale: 'en', // Fallback locale
  messages: loadLocaleMessages(), // Loaded locale messages
});

// Export the VueI18n instance
export default i18n;